import React, { useState, useEffect } from 'react';

interface VS { total_detectados:number; genero:{genero:string;total:number}[]; edad_grupos:{grupo:string;total:number}[]; comportamiento:{tipo:string;total:number}[]; tiempo_promedio_seg:number; tiempo_maximo_seg:number; }
const STORES=[{id:0,name:'Todas'},{id:1,name:'Niko 3'},{id:2,name:'Niko 4'},{id:3,name:'Niko 2'},{id:4,name:'Niko 5'},{id:5,name:'Niko 7'},{id:6,name:'Niko 1'}];
const CL:Record<string,string>={ingresando:'Ingresando',transitando:'Transitando',en_espera:'En espera',browsing:'Browsing'};
const CC:Record<string,string>={ingresando:'#3b82f6',transitando:'#f59e0b',en_espera:'#ef4444',browsing:'#10b981'};
const EC=['#6366f1','#3b82f6','#10b981','#f59e0b','#ef4444'];
const fmtS=(s:number)=>s>=60?Math.floor(s/60)+'m '+s%60+'s':s+'s';

export default function VisionPanel() {
  const [stats,setStats]=useState<VS|null>(null);
  const [sid,setSid]=useState(0);
  const [days,setDays]=useState(7);
  const [loading,setLoading]=useState(false);
  const tok=localStorage.getItem('pc_token')||'';
  useEffect(()=>{loadData();},[sid,days]);
  const loadData=async()=>{
    setLoading(true);
    try{
      const p=new URLSearchParams({days:days.toString()});
      if(sid>0)p.append('store_id',sid.toString());
      const r=await fetch('/api/vision/stats?'+p,{headers:{Authorization:'Bearer '+tok}});
      setStats(await r.json());
    }catch(e){}
    setLoading(false);
  };
  const tG=stats?.genero.reduce((a,b)=>a+b.total,0)||0;
  const tC=stats?.comportamiento.reduce((a,b)=>a+b.total,0)||0;
  const tE=stats?.edad_grupos.reduce((a,b)=>a+b.total,0)||0;
  const cM=stats?.genero.find(g=>g.genero==='M')?.total||0;
  const cF=stats?.genero.find(g=>g.genero==='F')?.total||0;
  const pM=tG>0?Math.round(cM/tG*100):50;
  const pF=100-pM;
  const noData=!stats||stats.total_detectados===0;
  const W=(p:{'style'?:React.CSSProperties;children?:React.ReactNode})=><div style={p.style}>{p.children}</div>;
  return (
    <div style={{padding:24,background:'#f0f2f5',minHeight:'100vh'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
        <div>
          <h1 style={{margin:0,fontSize:26,fontWeight:700,color:'#1a1a2e'}}>Perfil del Cliente</h1>
          <p style={{margin:'4px 0 0',color:'#666',fontSize:14}}>Genero - Edad - Comportamiento via IA</p>
        </div>
        <div style={{display:'flex',gap:12}}>
          <select value={sid} onChange={e=>setSid(Number(e.target.value))} style={{padding:'8px 12px',borderRadius:8,border:'1px solid #ddd',fontSize:14}}>
            {STORES.map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <select value={days} onChange={e=>setDays(Number(e.target.value))} style={{padding:'8px 12px',borderRadius:8,border:'1px solid #ddd',fontSize:14}}>
            <option value={1}>Hoy</option>
            <option value={7}>7 dias</option>
            <option value={14}>14 dias</option>
            <option value={30}>30 dias</option>
          </select>
          <button onClick={loadData} style={{padding:'8px 16px',borderRadius:8,background:'#1a1a2e',color:'#fff',border:'none',cursor:'pointer'}}>{loading?'...':'Actualizar'}</button>
        </div>
      </div>
      {noData && (
        <div style={{background:'#fff',borderRadius:16,padding:'60px 40px',textAlign:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
          <div style={{fontSize:64,marginBottom:16}}>&#128065;</div>
          <h2 style={{color:'#1a1a2e',margin:'0 0 8px'}}>Sin datos de vision aun</h2>
          <p style={{color:'#888',margin:0}}>La IA registrara datos cuando haya personas en las tiendas.</p>
          <p style={{color:'#aaa',fontSize:13,marginTop:8}}>InsightFace activo - Analiza cada 150 frames</p>
        </div>
      )}
      {!noData && stats && (
        <div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:16,marginBottom:20}}>
            <div style={{background:'#fff',borderRadius:16,padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <div style={{fontSize:28,marginBottom:8}}>&#128101;</div>
              <div style={{fontSize:28,fontWeight:700,color:'#1a1a2e'}}>{stats.total_detectados}</div>
              <div style={{fontSize:13,color:'#888',marginTop:4}}>Detectados</div>
            </div>
            <div style={{background:'#fff',borderRadius:16,padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <div style={{fontSize:28,marginBottom:8}}>&#128104;</div>
              <div style={{fontSize:28,fontWeight:700,color:'#3b82f6'}}>{pM}%</div>
              <div style={{fontSize:13,color:'#888',marginTop:4}}>Masculino</div>
            </div>
            <div style={{background:'#fff',borderRadius:16,padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <div style={{fontSize:28,marginBottom:8}}>&#128105;</div>
              <div style={{fontSize:28,fontWeight:700,color:'#ec4899'}}>{pF}%</div>
              <div style={{fontSize:13,color:'#888',marginTop:4}}>Femenino</div>
            </div>
            <div style={{background:'#fff',borderRadius:16,padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <div style={{fontSize:28,marginBottom:8}}>&#9201;</div>
              <div style={{fontSize:28,fontWeight:700,color:'#10b981'}}>{fmtS(stats.tiempo_promedio_seg)}</div>
              <div style={{fontSize:13,color:'#888',marginTop:4}}>Tiempo Prom.</div>
            </div>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:20}}>
            <div style={{background:'#fff',borderRadius:16,padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:600}}>Genero</h3>
              <div style={{display:'flex',height:24,borderRadius:12,overflow:'hidden',marginBottom:16}}>
                <div style={{width:pM+'%',background:'#3b82f6'}} />
                <div style={{width:pF+'%',background:'#ec4899'}} />
              </div>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:8}}>
                <span>Masculino</span><span style={{fontWeight:700,color:'#3b82f6'}}>{pM}% ({cM})</span>
              </div>
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <span>Femenino</span><span style={{fontWeight:700,color:'#ec4899'}}>{pF}% ({cF})</span>
              </div>
            </div>
            <div style={{background:'#fff',borderRadius:16,padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:600}}>Grupos de Edad</h3>
              {stats.edad_grupos.map((eg,i)=>{
                const p=tE>0?Math.round(eg.total/tE*100):0;
                return (
                  <div key={i} style={{marginBottom:12}}>
                    <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                      <span style={{fontSize:13}}>{eg.grupo}</span>
                      <span style={{fontSize:13,fontWeight:600,color:EC[i%5]}}>{p}%</span>
                    </div>
                    <div style={{height:8,background:'#f0f0f0',borderRadius:4}}>
                      <div style={{height:8,width:p+'%',background:EC[i%5],borderRadius:4}} />
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{background:'#fff',borderRadius:16,padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:600}}>Comportamiento</h3>
              {stats.comportamiento.map((c,i)=>{
                const p=tC>0?Math.round(c.total/tC*100):0;
                const col=CC[c.tipo]||'#888';
                return (
                  <div key={i} style={{marginBottom:12}}>
                    <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                      <span style={{fontSize:13}}>{CL[c.tipo]||c.tipo}</span>
                      <span style={{fontSize:13,fontWeight:600,color:col}}>{p}%</span>
                    </div>
                    <div style={{height:8,background:'#f0f0f0',borderRadius:4}}>
                      <div style={{height:8,width:p+'%',background:col,borderRadius:4}} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{marginTop:20,background:'#fff',borderRadius:16,padding:'16px 24px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',display:'flex',alignItems:'center',gap:12}}>
            <span style={{fontSize:14,color:'#666'}}>Tiempo maximo:</span>
            <strong style={{fontSize:18,color:'#1a1a2e'}}>{fmtS(stats.tiempo_maximo_seg)}</strong>
          </div>
        </div>
      )}
    </div>
  );
}
